import React from 'react';
import { PublicLayout } from '../components/PublicLayout';
import { Calendar, Award, Users, Globe } from 'lucide-react';

const programTimeline = [
  {
    year: '2000',
    title: 'Festival Pencak Silat Kepulauan Borneo dan Serantau',
    cat: 'Festival Antarabangsa',
    desc: 'Program festival seni silat bertaraf antarabangsa melibatkan perguruan dari seluruh kepulauan Borneo dan rantau serantau.',
    color: '#D71920',
  },
  {
    year: '2001',
    title: 'Konvensyen Guru-guru Silat Negeri Sarawak Ke-1',
    cat: 'Konvensyen',
    desc: 'Konvensyen pertama guru-guru silat negeri Sarawak bagi meningkatkan kemahiran, perkongsian ilmu dan penyeragaman pengajaran.',
    color: '#D4AF37',
  },
  {
    year: '2003',
    title: 'Festival Pencak Silat Antarabangsa & Konvensyen Guru-guru Ke-2',
    cat: 'Festival & Konvensyen',
    desc: 'Gabungan festival silat antarabangsa dan konvensyen guru-guru silat negeri Sarawak kali kedua.',
    color: '#D71920',
  },
  {
    year: '2006',
    title: 'Konvensyen Guru-guru Ke-3 & Perasmian Ibu Pejabat RSS',
    cat: 'Perasmian Bersejarah',
    desc: 'Konvensyen ke-3 seiring dengan majlis perasmian bersejarah Ibu Pejabat Rumpun Silat Sarawak.',
    color: '#0B0B0B',
  },
  {
    year: '2010',
    title: 'Konvensyen Guru-guru Silat Negeri Sarawak Ke-4',
    cat: 'Konvensyen',
    desc: 'Konvensyen keempat guru-guru silat negeri Sarawak meneruskan tradisi pembangunan ilmu dan kepimpinan silat.',
    color: '#D4AF37',
  },
  {
    year: '2020',
    title: 'Perhimpunan Guru-guru Silat Negeri Sarawak',
    cat: 'Perhimpunan Negeri',
    desc: 'Perhimpunan tahunan guru-guru silat seluruh Sarawak untuk mengeratkan silaturrahim dan perbincangan hala tuju silat negeri.',
    color: '#D71920',
  },
  {
    year: '2022',
    title: 'RSS Beach Games Mukah',
    cat: 'Sukan & Komuniti',
    desc: 'Program sukan silat dan komuniti di Mukah — menggabungkan pertandingan, demonstrasi dan aktiviti komuniti.',
    color: '#D4AF37',
  },
  {
    year: '2023',
    title: 'Sarawak Premier International Silat Championship',
    cat: 'Kejuaraan Antarabangsa',
    desc: 'Kejuaraan silat antarabangsa bertaraf premier yang dianjurkan oleh RSS Sarawak, menarik penyertaan dari pelbagai negara.',
    color: '#D71920',
  },
];

const jenisAktiviti = [
  { cat: 'Latihan & Pembangunan', icon: <Users size={18} />, color: '#D71920',
    desc: 'Kursus Asas Pengenalan Silat, Kursus Train Of Trainers (TOT), Muzakarah Guru-Guru Silat.' },
  { cat: 'Pertandingan & Kejuaraan', icon: <Award size={18} />, color: '#D4AF37',
    desc: 'SUKMA, Kejuaraan Kebangsaan, Kejuaraan Silat Sedunia, Sukan SEA, Sarawak Premier International.' },
  { cat: 'Hubungan Rasmi & Kerajaan', icon: <Globe size={18} />, color: '#0B0B0B',
    desc: 'Kunjungan hormat kepada pemimpin negeri, sidang agung, majlis rasmi dengan agensi kerajaan.' },
  { cat: 'Komuniti & Perayaan', icon: <Calendar size={18} />, color: '#D71920',
    desc: 'Ramah tamah Aidilfitri wilayah-wilayah RSS, program komuniti dan aktiviti pembangunan ahli.' },
];

const recentAktiviti = [
  { title: 'Kunjungan Hormat Tuan Yang Terutama Yang Dipertua Negeri Sarawak', year: 'Terkini', cat: 'Hubungan Rasmi' },
  { title: 'Konvensyen Guru-Guru Silat', year: 'Terkini', cat: 'Pendidikan' },
  { title: 'Sidang Agung Ke-15 RSS Sarawak', year: 'Terkini', cat: 'Pentadbiran' },
  { title: 'Kunjungan Hormat Timbalan Menteri Belia, Sukan dan Pembangunan Usahawan', year: 'Terkini', cat: 'Hubungan Kerajaan' },
  { title: 'Kursus Asas Pengenalan Silat', year: 'Berterusan', cat: 'Latihan' },
  { title: 'Kunjungan Hormat kepada YAB Premier Sarawak', year: 'Terkini', cat: 'Hubungan Rasmi' },
  { title: 'Rumah Terbuka Aidilfitri Premier Sarawak', year: 'Tahunan', cat: 'Komuniti' },
  { title: 'Ramah Tamah Aidilfitri Wilayah-Wilayah RSS', year: 'Tahunan', cat: 'Komuniti' },
  { title: 'Ramah Tamah Aidilfitri Peringkat Negeri', year: 'Tahunan', cat: 'Komuniti' },
  { title: 'Sukan Malaysia XXI Sarawak 2024', year: '2024', cat: 'Kejuaraan' },
  { title: 'Kursus Wasit Juri Peraturan Baharu Kebangsaan Peringkat Negeri', year: 'Terkini', cat: 'Latihan' },
  { title: 'Sarawak Premier International Silat Championship 2023', year: '2023', cat: 'Kejuaraan Antarabangsa' },
];

export default function Aktiviti() {
  return (
    <PublicLayout>
      {/* Page Header */}
      <div className="bg-[#0B0B0B] text-white py-16">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920] -mt-16 mb-16" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-3">Utama / Aktiviti</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold" data-testid="aktiviti-page-title">
            Aktiviti & Program RSS
          </h1>
          <p className="text-[#999] mt-3 text-sm sm:text-base max-w-2xl">
            Pelbagai program dan aktiviti yang dianjurkan oleh Rumpun Silat Sarawak untuk membangunkan komuniti silat negeri.
          </p>
        </div>
      </div>

      {/* Jenis Aktiviti */}
      <section className="bg-white py-14 border-b border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-5">Kategori Program</div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {jenisAktiviti.map((j, i) => (
              <div key={i} className="border border-[#E5E5E5] p-5 rounded hover:shadow-md transition-shadow" data-testid={`jenis-card-${i}`}>
                <div className="w-9 h-9 rounded flex items-center justify-center mb-4" style={{ backgroundColor: j.color + '15', color: j.color }}>
                  {j.icon}
                </div>
                <h3 className="font-bold text-[#0B0B0B] text-sm mb-2">{j.cat}</h3>
                <p className="text-xs text-[#777] leading-relaxed">{j.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Program Berskala Besar */}
      <section className="bg-[#F7F7F7] py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-3">Sejarah</div>
          <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-10">Program Berskala Besar RSS</h2>
          <div className="relative">
            <div className="hidden lg:block absolute left-[88px] top-0 bottom-0 w-px bg-[#E5E5E5]" />
            <div className="space-y-4">
              {programTimeline.map((p, i) => (
                <div key={i} className="flex gap-5 items-start" data-testid={`program-item-${i}`}>
                  <div className="flex-shrink-0 w-20 text-right pt-1">
                    <span className="inline-block text-white text-xs font-extrabold px-2 py-1 rounded" style={{ backgroundColor: p.color }}>
                      {p.year}
                    </span>
                  </div>
                  <div className="hidden lg:flex items-start pt-3">
                    <div className="w-3 h-3 rounded-full bg-white border-2 flex-shrink-0" style={{ borderColor: p.color }} />
                  </div>
                  <div className="flex-1 bg-white border border-[#E5E5E5] rounded p-5 hover:border-[#D71920]/30 hover:shadow-sm transition-all">
                    <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color: p.color }}>{p.cat}</span>
                    <h3 className="font-bold text-[#0B0B0B] text-sm mt-1 mb-2 leading-tight">{p.title}</h3>
                    <p className="text-xs text-[#777] leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Recent Activities */}
      <section className="bg-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-3">Aktiviti Terkini</div>
          <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Aktiviti & Program RSS Sarawak</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {recentAktiviti.map((a, i) => (
              <div
                key={i}
                className="border border-[#E5E5E5] p-5 rounded hover:border-[#D71920]/30 hover:shadow-sm transition-all bg-white"
                data-testid={`aktiviti-card-${i}`}
              >
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-1.5 h-1.5 bg-[#D71920] rounded-full flex-shrink-0" />
                  <span className="text-[10px] font-bold text-[#D71920] uppercase tracking-wide">{a.cat}</span>
                  <span className="ml-auto text-[10px] text-[#999]">{a.year}</span>
                </div>
                <h3 className="font-semibold text-[#0B0B0B] text-sm leading-snug">{a.title}</h3>
              </div>
            ))}
          </div>
          <div className="mt-8 p-5 bg-[#F7F7F7] border border-[#E5E5E5] rounded text-sm text-[#666] flex items-start gap-3">
            <Calendar size={16} className="text-[#D71920] flex-shrink-0 mt-0.5" />
            <p className="leading-relaxed">
              Kalendar aktiviti terkini akan dikemaskini oleh Sekretariat RSS Sarawak. Untuk maklumat program akan datang,
              sila <a href="/hubungi" className="text-[#D71920] font-semibold hover:underline">hubungi sekretariat</a>.
            </p>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
